exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wrapper-exclude-provider {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  width: 100%; }\n\n.btn-select {\n  display: -ms-flexbox;\n  display: flex;\n  width: 90%;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  margin: 0.5rem; }\n\n.selector {\n  height: 40vh !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/dual-list-box/components/dual-list-box/dual-list-box.component.scss
// module id = 2183
// module chunks = 66